import { Directive, ElementRef, Renderer2, AfterViewInit, inject, ViewContainerRef, ComponentRef } from '@angular/core'
import { VisibilityIconComponent, VisibilityOffIconComponent } from '../components/icons/brand-icons.component'

@Directive({
  selector: '[appTogglePassword]'
})
export class TogglePasswordDirective implements AfterViewInit {
  private visible = false
  private toggleButton!: HTMLButtonElement
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private iconRef: ComponentRef<any> | null = null

  private el = inject(ElementRef<HTMLInputElement>)
  private renderer = inject(Renderer2)
  private vcr = inject(ViewContainerRef)

  ngAfterViewInit(): void {
    const input = this.el.nativeElement
    this.renderer.setAttribute(input, 'type', 'password')

    const parent = this.renderer.parentNode(input)
    this.renderer.setStyle(parent, 'position', 'relative')

    this.toggleButton = this.renderer.createElement('button')
    this.renderer.setAttribute(this.toggleButton, 'type', 'button')

    this.renderer.setStyle(this.toggleButton, 'position', 'absolute')
    this.renderer.setStyle(this.toggleButton, 'top', '50%')
    this.renderer.setStyle(this.toggleButton, 'right', '0.75rem')
    this.renderer.setStyle(this.toggleButton, 'transform', 'translateY(-50%)')
    this.renderer.setStyle(this.toggleButton, 'height', '1.5rem')
    this.renderer.setStyle(this.toggleButton, 'width', '1.5rem')
    this.renderer.setStyle(this.toggleButton, 'background', 'none')
    this.renderer.setStyle(this.toggleButton, 'border', 'none')
    this.renderer.setStyle(this.toggleButton, 'padding', '0')
    this.renderer.setStyle(this.toggleButton, 'cursor', 'pointer')
    this.renderer.setStyle(this.toggleButton, 'z-index', '10')
    this.renderer.setStyle(this.toggleButton, 'display', 'flex')
    this.renderer.setStyle(this.toggleButton, 'align-items', 'center')
    this.renderer.setStyle(this.toggleButton, 'justify-content', 'center')

    this.renderer.appendChild(parent, this.toggleButton)

    this.updateIcon()

    this.renderer.listen(this.toggleButton, 'click', () => {
      this.visible = !this.visible
      this.renderer.setAttribute(input, 'type', this.visible ? 'text' : 'password')
      this.updateIcon()
    })
  }

  private updateIcon() {
    if (this.iconRef) {
      this.iconRef.destroy()
    }

    this.iconRef = this.vcr.createComponent(this.visible ? VisibilityOffIconComponent : VisibilityIconComponent)

    const iconElement = this.iconRef.location.nativeElement
    this.renderer.setStyle(iconElement, 'height', '100%')
    this.renderer.setStyle(iconElement, 'width', '100%')

    this.toggleButton.innerHTML = ''
    this.toggleButton.appendChild(iconElement)
  }
}
